import React, { useEffect, useRef } from "react";

export default function SlateForm({ formEmbedCode }) {
  const formIframeRef = useRef(null);

  useEffect(() => {
    if (formIframeRef.current && formEmbedCode) {
      formIframeRef.current.contentWindow.document.open();
      formIframeRef.current.contentWindow.document.write(formEmbedCode);
      formIframeRef.current.contentWindow.document.close();
    }
  }, [formEmbedCode]);

  return (
    <div id='slate-form' data-testid='slate-form'>
      <iframe
        ref={formIframeRef}
        className="slate-form-iframe"
        title="Slate Form Iframe"
        width="100%"
      />
    </div>

  );
}
